import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import '@/index.css'
import SignUpIdScreen from '../screens/SignUpIdScreen'
import { ensureUniversalLoginContext } from '../utils/helpers/universalLoginContext.ts'

async function bootstrap() {
  await ensureUniversalLoginContext('signup-id')
  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <SignUpIdScreen />
    </StrictMode>,
  )
}

bootstrap()

